module.exports = __webpack_public_path__ + "static/media/02-d-calendar.b499e042.png";